import React from 'react'
import './css/Packages.css'
import { Helmet } from 'react-helmet';

const Packages = () => {
    return (
        <>
            <Helmet>
                <title>Packages</title>
                <meta name="keywords" content="" />
                <meta name="description" content="package description" />
            </Helmet>
            <h3>Packages Page Comming soon</h3>
        </>
    )
}

export default Packages;